
  import { Vue, Component, Prop } from "vue-property-decorator";
  import RouteParams from "@/entities/RouteParams";
  import RouteNames from "@/entities/RouteNames";
  import { Manager_Contractor } from "@/generated/graphql";
  import ItemChipsWithMore from "@/components/common/ItemChipsWithMore.vue";
  import ItemChipsData from "@/entities/ItemChipsData";

  @Component({
    components: {
      ItemChipsWithMore,
    },
  })
  export default class ManagerChips extends Vue {
    @Prop({ type: Array, required: true }) readonly managers!: Manager_Contractor[];
    @Prop({ type: String, required: true }) readonly contractorId!: string;

    RouteNames = RouteNames;

    get navigateToManagersTab(): RouteParams<{ id: string }> {
      return {
        name: RouteNames.CONTRACTOR_DETAILS_MANAGERS,
        params: {
          id: this.contractorId,
        },
      };
    }

    get isEmpty(): boolean {
      return this.managersData.length === 0;
    }

    get managersData(): ItemChipsData[] {
      if (!this.managers.length) {
        return [];
      }

      return this.managers.map(({ manager }) => {
        return {
          id: manager.id,
          name: `${manager.user.given_name} ${manager.user.family_name}`,
          avatar: manager.user.avatar || undefined,
        };
      });
    }
  }
